import scss from "./index.scss";
import React from "react";

export default function Footer() {
  return (
    <div className="footer">
      <p>Paulina Lukarska © 2020 </p>
    </div>
  );
}
